module.exports = __webpack_public_path__ + "static/media/supply_chain.3ff58ad0.png";